import React, { useContext } from "react";
import { FlexContainer } from "../../../../shared/components/styled/Container.styled";
import FormItem from "../../../../shared/components/form/FormItem";
import {
  formatSocialSecurityNumber,
  getLoanId,
} from "../../../../shared/utils/utility-functions";
import {
  LOAN_NICKNAME_MAX_LENGTH,
  LOAN_NUMBER_ALPHANUMERIC_ONLY_ERROR_MESSAGE,
  LOAN_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE,
  LOAN_NUMBER_MAX_LENGTH,
  SSN_NUMBERS_DASHES_ERROR_MESSAGE,
} from "../../../../shared/constants/UserProfile.constants";
import { AuthContext } from "../../../../contexts/AuthContext";
import { useMediaQuery, useTheme } from "@mui/material";  

const onlyAlphanumericAllowed = /^[a-zA-Z0-9]+$/;
const nonAlphanumeric = /[^a-zA-Z0-9]/g;
const onlyNumbersAndDashesAllowed = /^[\d-]+$/;

const AddLoanForm = ({
  loanNumber = "",
  setLoanNumber = () => {},
  socialSecurityNumber = "",
  setSocialSecurityNumber = () => {},
  loanNickname = "",
  setLoanNickname = () => {},
  loanNumberErrorMessage = "",
  setLoanNumberErrorMessage = () => {},
  socialSecurityNumberErrorMessage = "",
  setSocialSecurityNumberErrorMessage = () => {},
}) => {
  const { loans } = useContext(AuthContext);
  const existingLoanNumbers = (Array.isArray(loans) ? loans : []).map((item) =>
    getLoanId(item).trim().toUpperCase(),
  );

  const checkLoanNumberValidity = () => {
    if (!onlyAlphanumericAllowed.test(loanNumber)) {
      setLoanNumberErrorMessage(LOAN_NUMBER_ALPHANUMERIC_ONLY_ERROR_MESSAGE);
    } else if (existingLoanNumbers.includes(loanNumber.trim().toUpperCase())) {
      setLoanNumberErrorMessage(LOAN_NUMBER_ALREADY_EXISTS_ERROR_MESSAGE);
    } else {
      setLoanNumberErrorMessage("");
    }
  };

  const handleLoanNumberChange = (e) => {
    const sanitized = e.target.value
      .replace(nonAlphanumeric, "")
      .slice(0, LOAN_NUMBER_MAX_LENGTH);
    setLoanNumber(sanitized);
  };

  const checkSocialSecurityNumberValidity = () => {
    if (!onlyNumbersAndDashesAllowed.test(socialSecurityNumber)) {
      setSocialSecurityNumberErrorMessage(SSN_NUMBERS_DASHES_ERROR_MESSAGE);
    } else {
      setSocialSecurityNumberErrorMessage("");
    }
  };

  const handleSSNChange = (e) => {
    const formattedSocialSecurityNumber = formatSocialSecurityNumber(
      e.target.value,
    );
    setSocialSecurityNumber(formattedSocialSecurityNumber);
  };

  const handleLoanNicknameChange = (e) => {
    setLoanNickname(e.target.value.slice(0, LOAN_NICKNAME_MAX_LENGTH));
  };

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <FlexContainer
      padding={isMobile ? "25px 0 0 0" : "25px 0 35px 0"}
      flexdirection="column"
      gap="10px"
      width="100%"
    >
      <FormItem
        elementWidth="25%"
        label="Loan Number"
        inputType="input"
        value={loanNumber}
        setValue={handleLoanNumberChange}
        blurHandler={(e) => checkLoanNumberValidity()}
        errorMessage={loanNumberErrorMessage}
        inputProps={{
          type: "text",
          maxLength: LOAN_NUMBER_MAX_LENGTH,
          inputMode: "text",
          style: {
            textAlign: "start",
          },
        }}
      />
      <FormItem
        elementWidth="25%"
        label="Social Security Number"
        inputType="input"
        value={socialSecurityNumber}
        setValue={(e) => handleSSNChange(e)}
        blurHandler={(e) => checkSocialSecurityNumberValidity()}
        errorMessage={socialSecurityNumberErrorMessage}
        inputProps={{
          type: "tel",
          style: {
            textAlign: "start",
          },
        }}
      />
      <FormItem
        elementWidth="25%"
        label="Loan Nickname"
        inputType="input"
        value={loanNickname}
        setValue={handleLoanNicknameChange}
        inputProps={{
          type: "text",
          maxLength: LOAN_NICKNAME_MAX_LENGTH,
          style: {
            textAlign: "start",
          },
        }}
      />
    </FlexContainer>
  );
};

export default AddLoanForm;